module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightSemiExtIt.087dd1c.woff";